// src/chatbot/ChatbotCore.js
import React, { useState, useRef, useEffect } from 'react';
import { ReactMediaRecorder } from "react-media-recorder";
import './ChatbotCore.css';


function ChatbotCore({ title, baseQuestions, interviewContext }) { 
  const [questions, setQuestions] = useState([baseQuestions[0].text]);
  const [answers, setAnswers] = useState([""]);
  const [current, setCurrent] = useState(0);
  const [baseIndex, setBaseIndex] = useState(0);
  const [followupCount, setFollowupCount] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [showAnswers, setShowAnswers] = useState(false);
  const [userName, setUserName] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);
  const [recordingTimeLeft, setRecordingTimeLeft] = useState(120);
  const [timerInterval, setTimerInterval] = useState(null);

  const [hasSubmitted, setHasSubmitted] = useState(false); // 🟨 NEW
  const allowLeaveRef = useRef(false); // 🟨 NEW: lets us skip beforeunload after user confirms back



const [editingIndex, setEditingIndex] = useState(null); 
const [draftAnswer, setDraftAnswer] = useState('');   
const [appendOpen, setAppendOpen] = useState(false);               // 🟨 NEW
const [appendIndex, setAppendIndex] = useState(null);              // 🟨 NEW
const [appendText, setAppendText] = useState('');                  // 🟨 NEW
const [isTranscribingAppend, setIsTranscribingAppend] = useState(false); // 🟨 NEW

const [appendIsRecording, setAppendIsRecording] = useState(false); // 🟨 NEW
const [appendTimeLeft, setAppendTimeLeft] = useState(120);         // 🟨 NEW
const [appendTimerInterval, setAppendTimerInterval] = useState(null); // 🟨 NEW
  

// 🟨 NEW: fallback if neither per-question nor set-level context is provided
 const DEFAULT_FOLLOWUP_CONTEXT =
  "You are a thoughtful and respectful interviewer. Base your follow-up only on the interviewee’s last answer. If no follow-up is needed, respond exactly with 'NO_FOLLOW_UP'.";

// 🟨 NEW: per-question placeholder with a fallback
const currentPlaceholder =
  baseQuestions[baseIndex]?.placeholder ||
  "Type here, or click the Start Transcribing button below and we'll transcribe into this box…";


const closeAppendPanel = () => {                      // 🟨 NEW
  if (appendTimerInterval) clearInterval(appendTimerInterval);
setAppendTimerInterval(null);   // 🟨 NEW
  setAppendIsRecording(false);                        // 🟨 NEW
  setAppendOpen(false);                               // 🟨 NEW
  setAppendText('');                                  // 🟨 NEW
  setAppendIndex(null);                               // 🟨 NEW
};                                                    // 🟨 NEW

  const handleInput = (e) => {
    const updated = [...answers];
    updated[current] = e.target.value;
    setAnswers(updated);
  };
  
  const startEdit = (idx) => {                
  setEditingIndex(idx);                      
  setDraftAnswer(answers[idx] || '');        
};                                           

const cancelEdit = () => {                   
  setEditingIndex(null);                     
  setDraftAnswer('');                        
};                                           

const saveEdit = () => {                     
  const updated = [...answers];              
  updated[editingIndex] = draftAnswer;       
  setAnswers(updated);                       
  setEditingIndex(null);                     
  setDraftAnswer('');                        
};       

// 🟨 NEW: leave the review screen and resume the interview
const returnToInterview = () => {
  // close any append panel and timers just in case
  if (appendOpen) closeAppendPanel();            // 🟨 NEW
  setCompleted(false);                           // 🟨 NEW
  setShowAnswers(false);                         // 🟨 NEW (hide transcript when resuming)
};


                                                                  // 🟨 NEW
                                   
// 🟨 NEW: jump to the final review screen (no submission yet)
const goToFinalReview = () => {
  if (isRecording || appendIsRecording) {
    alert('Please stop the recording first, then continue to Submit.');
    return;
  }
  setCompleted(true);    // 🟨 NEW
  setShowAnswers(true);  // 🟨 NEW (keeps the transcript visible)
};

  
  // All pre-planned questions that haven't been asked yet (main questions only)
const upcomingBaseQuestions = baseQuestions.slice(baseIndex + 1);

  const handleTranscribeBlob = async (blobUrl) => {
    try {
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      const file = new File([blob], 'recording.wav', { type: 'audio/wav' });

      const formData = new FormData();
      formData.append('file', file);
      formData.append('model', 'whisper-1');
      formData.append('language', 'en');

      const result = await fetch('https://api.openai.com/v1/audio/transcriptions', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer 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'
        },
        body: formData
      });

      const data = await result.json();

      if (data.text) {
        const updatedAnswers = [...answers];
        updatedAnswers[current] = (updatedAnswers[current] || '') + ' ' + data.text;
        setAnswers(updatedAnswers);
      } else {
        console.error(data);
        alert('Failed to transcribe. Check console for details.');
      }
    } catch (error) {
      console.error('Transcription error:', error);
      alert('There was a problem transcribing your audio.');
    }
  };

  const generateFollowUp = async (userAnswer, systemPrompt) => {
    const res = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer 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'
      },
      body: JSON.stringify({
        model: 'gpt-4',
        messages: [
          
            { role: 'system', content: systemPrompt },   
            { role: 'user', content: userAnswer }
        ],
        temperature: 0.7
      })
    });

    const data = await res.json();
    return data.choices?.[0]?.message?.content?.trim();
  };

  const nextQuestion = async () => {
  const currentAnswer = answers[current];
  const maxFollowups = baseQuestions[baseIndex]?.followups || 0;

  // 1) Try to insert a follow-up first (if allowed)
  if (followupCount < maxFollowups && currentAnswer) {
  // 🟨 NEW: per-question override → set-level → fallback
  const effectiveContext =
    baseQuestions[baseIndex]?.context ||
    interviewContext ||
    DEFAULT_FOLLOWUP_CONTEXT;

  const followUp = await generateFollowUp(currentAnswer, effectiveContext); // 🟨 CHANGED
  if (followUp && followUp !== "NO_FOLLOW_UP") {
    // (your existing insert/advance code stays the same)
    const updatedQuestions = [...questions];
    const updatedAnswers = [...answers];
    updatedQuestions.splice(current + 1, 0, followUp);
    updatedAnswers.splice(current + 1, 0, "");
    setQuestions(updatedQuestions);
    setAnswers(updatedAnswers);
    setCurrent(current + 1);
    setFollowupCount(followupCount + 1);
    return;
  }
}

  // 2) No follow-up (or we've hit the cap): advance to next base question, or finish
  const nextBaseIndex = baseIndex + 1;
  if (nextBaseIndex >= baseQuestions.length) {
    setCompleted(true);
    setShowAnswers(true); // auto-open transcript at the end
    return;
  }

  const updatedQuestions = [...questions, baseQuestions[nextBaseIndex].text];
  const updatedAnswers = [...answers, ""];
  setQuestions(updatedQuestions);
  setAnswers(updatedAnswers);
  setCurrent(updatedQuestions.length - 1);
  setBaseIndex(nextBaseIndex);
  setFollowupCount(0);
};


  const skipQuestion = () => {                          // 🟨 REPLACED
  // Always jump to the next base question; ignore follow-ups
  const nextBaseIndex = baseIndex + 1;

  // If there are no more base questions, finish & show review
  if (nextBaseIndex >= baseQuestions.length) {
    setCompleted(true);
    setShowAnswers(true);
    return;
  }

  // Append the next base question and move the cursor there
  const updatedQuestions = [...questions, baseQuestions[nextBaseIndex].text];
  const updatedAnswers  = [...answers, ""];
  setQuestions(updatedQuestions);
  setAnswers(updatedAnswers);
  setCurrent(updatedQuestions.length - 1);
  setBaseIndex(nextBaseIndex);
  setFollowupCount(0);
};

  const addToPrevious = () => {
  const prev = prompt("Which previous question would you like to add to? (1-" + questions.length + ")"); // 🟨 CHANGED
  const index = parseInt(prev, 10) - 1; // 🟨 CHANGED
  if (!isNaN(index) && index >= 0 && index < answers.length) {
    setAppendIndex(index);   // 🟨 NEW
    setAppendText('');       // 🟨 NEW
    setAppendOpen(true);     // 🟨 NEW
    setShowAnswers(true);    // 🟨 NEW
  }
};

// 🟨 NEW: transcribe into the append textarea
const handleTranscribeBlobToAppend = async (blobUrl) => { // 🟨 NEW
  try {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    const file = new File([blob], 'append.wav', { type: 'audio/wav' });

    const formData = new FormData();
    formData.append('file', file);
    formData.append('model', 'whisper-1');
    formData.append('language', 'en');

    const result = await fetch('https://api.openai.com/v1/audio/transcriptions', {
      method: 'POST',
      headers: { Authorization: 'Bearer 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' }, 
      body: formData
    });

    const data = await result.json();
    if (data.text) setAppendText(prev => (prev ? prev + ' ' : '') + data.text);
    else alert('Failed to transcribe.');
  } catch (e) {
    console.error(e);
    alert('There was a problem transcribing your audio.');
  }
}; // 🟨 NEW

// 🟨 NEW: commit the append text into the chosen answer
const commitAppend = () => {                               // 🟨 NEW
  if (appendIndex === null) return;
  const text = appendText.trim();
  if (!text) { setAppendOpen(false); setAppendText(''); setAppendIndex(null); return; }
  const updated = [...answers];
  updated[appendIndex] = (updated[appendIndex] || '') + `\n[Added later]: ${text}`;
  setAnswers(updated);
  setAppendOpen(false);
  setAppendText('');
  setAppendIndex(null);
}; // 🟨 NEW


  const getAnswerWordCount = () => {
    return answers.reduce((total, answer) => {
      const words = answer?.trim().split(/\s+/) || [];
      return total + words.filter(Boolean).length;
    }, 0);
  };

const submitResponses = async () => {
  // 🟨 NEW: robust name check (handles undefined, null, numbers, whitespace)
  const nameSafe = String(userName ?? '').trim(); // 🟨 NEW
  if (!nameSafe) {                                // 🟨 NEW
    alert('Please enter your name before submitting.'); // 🟨 NEW
    return;                                       // 🟨 NEW
  }

  try {
    const res = await fetch('/api/sendTranscriptMailgun', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ answers, questions, userName: nameSafe }) // 🟨 NEW (use trimmed name)
    });

    // 🟨 NEW: try to parse JSON; if it fails, keep an empty object
    const data = await res.json().catch(() => ({})); // 🟨 NEW

    if (!res.ok) {
      // 🟨 NEW: prefer server message if present; otherwise show status
      const msg = data?.error || `Send failed (${res.status})`;
      throw new Error(msg);
    }

    alert("Your responses have been submitted. You can now close this window");
    setHasSubmitted(true);
  } catch (error) {
    // 🟨 NEW: always show the specific error text
    const msg = (error && typeof error.message === 'string' && error.message) || 'Error sending responses.';
    alert(msg);
  }
};



// 🟨 NEW: intercept browser Back until they submit
useEffect(() => {
  if (hasSubmitted) return; // once submitted, don’t trap back

  const onPopState = () => {
    const ok = window.confirm("You haven't submitted yet. Leave the interview?");
    if (ok) {
      // user confirmed leaving: allow unload without a second prompt
      allowLeaveRef.current = true;
      window.removeEventListener('popstate', onPopState);
      history.back(); // actually go back one more entry
    } else {
      // stay on this page: re-insert our guard entry
      history.pushState(null, '', document.URL);
    }
  };

  // Insert a guard entry so the first Back hits popstate instead of leaving
  history.pushState(null, '', document.URL);
  window.addEventListener('popstate', onPopState);

  return () => {
    window.removeEventListener('popstate', onPopState);
  };
}, [hasSubmitted]); // 🟨 NEW


// 🟨 NEW: warn on browser back/refresh/close until they’ve submitted
useEffect(() => {
  const handleBeforeUnload = (e) => {
    if (hasSubmitted || allowLeaveRef.current) return; // 🟨 CHANGED
    e.preventDefault();
    e.returnValue = '';            // shows the generic “Leave site?” prompt
  };

  window.addEventListener('beforeunload', handleBeforeUnload);
  return () => window.removeEventListener('beforeunload', handleBeforeUnload);
}, [hasSubmitted]);


// 🟨 NEW: Stop the MAIN countdown if recording stops, or on unmount
useEffect(() => {
  if (!isRecording && timerInterval) {
    clearInterval(timerInterval);
    setTimerInterval(null);           // 🟨 NEW
  }
  return () => {
    if (timerInterval) clearInterval(timerInterval);
  };
}, [isRecording, timerInterval]);      // 🟨 NEW

// 🟨 NEW: Stop the APPEND countdown if panel closes or recording stops, or on unmount
useEffect(() => {
  const panelClosed = !appendOpen;
  const notRecording = !appendIsRecording;

  if ((panelClosed || notRecording) && appendTimerInterval) {
    clearInterval(appendTimerInterval);
    setAppendTimerInterval(null);     // 🟨 NEW
  }
  return () => {
    if (appendTimerInterval) clearInterval(appendTimerInterval);
  };
}, [appendOpen, appendIsRecording, appendTimerInterval]); // 🟨 NEW


  return (
    <div className="App" style={{ padding: 20, maxWidth: 600, margin: 'auto', fontFamily: "'Segoe UI', sans-serif" }}>
      <img src="/FD_new_light.png" alt="Fireside Dispatches logo" style={{ maxWidth: '200px', marginBottom: '1rem', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
      <h1 style={{ textAlign: 'center' }}>{title}</h1>
      <p style={{ fontSize: '1rem', color: '#666', marginTop: '-0.5rem', textAlign: 'center' }}>
        You can speak or type your answers - or do both. Click 'Start Recording' to begin speaking. Click 'Stop and transcribe' to save what you said. You can record multiple times for each answer - just click 'Start Recording' again to add more. Each recording can be up to 2 minutes long, so you don’t lose anything. 
      </p>
	   <p style={{ fontSize: '1rem', color: '#666', marginTop: '-0.5rem', textAlign: 'center' }}>
        <b>Don't click 'Submit' yet!</b>
      </p>
	   <p style={{ fontSize: '1rem', color: '#666', marginTop: '-0.5rem', textAlign: 'center' }}>
        When you're happy with your answer click 'Save & Next'  You then might be asked follow-on questions - answer these in the same way or press 'Skip' if you have no further detail to add. 
      </p>
	  <p style={{ fontSize: '1rem', color: '#666', marginTop: '-0.5rem', textAlign: 'center' }}>
        When you've finished entirely, click 'Submit' and then confirm this again on the next page.
      </p>

      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="name"><strong>Your Name:</strong></label><br />
        <input
          id="name"
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          style={{ width: '100%', padding: '0.5rem', fontSize: '1rem' }}
        />
      </div>

      {!completed ? (
        <>
          <p><strong>Q{current + 1}:</strong> {questions[current]}</p>
          <textarea rows="12" style={{ width: '100%' }} value={answers[current]} onChange={handleInput} placeholder={currentPlaceholder} />
          {/* Audio controls */}
          <ReactMediaRecorder
            audio
            onStop={(blobUrl) => {
              setIsTranscribing(true);
              handleTranscribeBlob(blobUrl).finally(() => {
                setIsTranscribing(false);
              });
            }}
            render={({ startRecording, stopRecording }) => {
             
              return (
                <div style={{ textAlign: 'center' }}>


{isRecording ? (
  <>
    {/* ✅ Red countdown bar while recording */}
    <div style={{
      height: '20px',
      width: '100%',
      backgroundColor: '#eee',
      borderRadius: '5px',
      marginBottom: '0.5rem',
      overflow: 'hidden'
    }}>
      <div style={{
        height: '100%',
        width: `${(recordingTimeLeft / 120) * 100}%`,
        backgroundColor: '#ff4d4f',
        transition: 'width 1s linear'
      }} />
    </div>

    {/* Stop button */}
          <button
      className="btn btn--danger"
      onClick={() => {
        stopRecording();
        setIsRecording(false);
        if (timerInterval) clearInterval(timerInterval);
		setTimerInterval(null); // 🟨 NEW
      }}
    >
      ⏹️ Stop & Transcribe
    </button>
  </>
) : (
  <button
    className="btn"
    onClick={() => {
      setIsRecording(true);
      setRecordingTimeLeft(120);
      startRecording();
      const interval = setInterval(() => {
        setRecordingTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            stopRecording();
            setIsRecording(false);
			setTimerInterval(null);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      setTimerInterval(interval);
    }}
  >
    🎙️ Start Recording
  </button>
)}
   </div>
    );
  }}
/>

{isTranscribing && <div style={{ color: 'blue' }}>Transcribing...</div>}

<div style={{ marginTop: 10, textAlign: 'center' }}>
  <button className="btn" onClick={() => setShowAnswers(v => !v)}>  {showAnswers ? '🔼 Hide Transcript' : '🔍 Show Transcript'}</button>
  <button className="btn" onClick={addToPrevious}>➕ Add to a Previous Answer</button>
    <button className="btn"    onClick={nextQuestion}    aria-label="Save answer and go to the next question"    title="Save answer and go to the next question"  >
    💾 Save & Next  </button>
  <button className="btn" onClick={skipQuestion}>Skip ⏭️</button>
  {/* 🟨 NEW: Submit is always available */}
<button
  className="btn btn--success"
  onClick={goToFinalReview}                           
  disabled={isRecording || appendIsRecording}
  title={isRecording || appendIsRecording
    ? 'Stop recording to continue'
    : 'Go to final review & submit'}
>
  ✅ Submit Now
</button>

</div>
                


          
        </>
     ) : (
  <>
    <p>You're all done. Ready to submit?</p>
    <div className="actions">
      {/* 🟨 NEW: go back to the interview */}
      <button className="btn" onClick={returnToInterview}>
        ⬅️ Return to Interview
      </button>
      <button className="btn" onClick={addToPrevious}>
        ➕ Add to a Previous Answer
      </button>
      <button className="btn" onClick={submitResponses}>
        ✅ Submit Responses
      </button>
    </div>
  </>
)}

{/* 🟨 NEW: Voice/typed append panel */}
{appendOpen && (
  <div className="append-panel" style={{ marginTop: 20, padding: '1rem', border: '1px solid #eee', borderRadius: '8px' }}>
    <h3>Add to Answer Q{(appendIndex ?? 0) + 1}</h3>
    <textarea
      className="answer-editor"
      value={appendText}
      onChange={(e) => setAppendText(e.target.value)}
      placeholder="Type here, or click the Start Transcribing button below and we'll transcribe into this box…"
    />
   {/* 🟨 APPEND RECORDER (replace this block only) */}
<ReactMediaRecorder
  audio
  onStop={(blobUrl) => {
    setIsTranscribingAppend(true);
    handleTranscribeBlobToAppend(blobUrl).finally(() => setIsTranscribingAppend(false));
  }}
  render={({ startRecording, stopRecording }) => (
    <div style={{ textAlign: 'center', marginTop: '0.5rem' }}>
      {appendIsRecording ? (
        <>
          {/* 🟨 NEW countdown bar */}
          <div style={{
            height: '20px',
            width: '100%',
            backgroundColor: '#eee',
            borderRadius: '5px',
            marginBottom: '0.5rem',
            overflow: 'hidden'
          }}>
            <div style={{
              height: '100%',
              width: `${(appendTimeLeft / 120) * 100}%`,
              backgroundColor: '#ff4d4f',
              transition: 'width 1s linear'
            }} />
          </div>

          <button
            className="btn btn--danger"
            onClick={() => {
              stopRecording();
              setAppendIsRecording(false);
              if (appendTimerInterval) clearInterval(appendTimerInterval);
			  setAppendTimerInterval(null); // 🟨 NEW
            }}
          >
            ⏹️ Stop & Transcribe
          </button>
        </>
      ) : (
        <button
          className="btn"
          onClick={() => {
            setAppendIsRecording(true);   // 🟨
            setAppendTimeLeft(120);       // 🟨
            startRecording();             // 🟨

            const interval = setInterval(() => {       // 🟨
              setAppendTimeLeft(prev => {
                if (prev <= 1) {
                  clearInterval(interval);
                  stopRecording();
                  setAppendIsRecording(false);
				  setAppendTimerInterval(null); 
                  return 0;
                }
                return prev - 1;
              });
            }, 1000);

            setAppendTimerInterval(interval);          // 🟨
          }}
        >
          🎙️ Start Recording
        </button>
      )}
    </div>
  )}
/>

    {isTranscribingAppend && <div style={{ color: 'blue', marginTop: '0.5rem' }}>Transcribing...</div>}
    <div className="answer-actions">
	    <button className="btn" onClick={closeAppendPanel}>✖️ Cancel</button>  {/* 🟨 CHANGED */}
      <button className="btn" onClick={commitAppend}>💾 Save</button> {/* 🟨 NEW */}
  
    </div>
  </div>
)}


 {showAnswers && (
  <div style={{ marginTop: 30 }}>
    <h3>Transcript</h3>
    <p><em>Current word Count: {getAnswerWordCount()}</em></p>

    {questions.map((q, idx) => (
      <div key={idx}>
        <strong>Q{idx + 1}:</strong> {q}<br />

        {editingIndex === idx ? (
          <>
            {/* 🟨 NEW: inline editor */}
            <textarea
              className="answer-editor"
              value={draftAnswer}
              onChange={(e) => setDraftAnswer(e.target.value)}
            />
            <div className="answer-actions">
              <button className="btn" onClick={saveEdit}>💾 Save</button>
              <button className="btn" onClick={cancelEdit}>✖️ Cancel</button>
            </div>
            {/* 🟨 NEW end */}
          </>
        ) : (
          <>
            <em>{answers[idx] || '[No answer yet]'}</em>
            <div className="answer-actions">
              <button
                className="btn"
                onClick={() => startEdit(idx)}
                disabled={!answers[idx]}
                title={answers[idx] ? 'Edit this answer' : 'No answer to edit'}
              >
                ✏️ Edit
              </button>
            </div>
          </>
        )}

        <hr />
      </div>
    ))}

    {/* 🟨 NEW: Upcoming questions (unstyled list) */}
    {upcomingBaseQuestions.length > 0 && (
      <>
        <h3>Upcoming questions</h3>
        <ul className="upcoming-list">
          {upcomingBaseQuestions.map((q, i) => (
            <li key={q.id || i}>{q.text}</li>
          ))}
        </ul>
      </>
    )}
    {/* 🟨 NEW end */}
  </div>
)}


    </div>
  );
}

export default ChatbotCore;
